export default "__VITE_ASSET__DGBQFVPn__"